import { Schema } from 'effect'

/**
 * Insurance type
 */
const InsuranceSchema = Schema.Literals(['GKV', 'PKV', 'SELFPAY'])
export type Insurance = Schema.Schema.Type<typeof InsuranceSchema>

/**
 * Search result status from the server
 */
export type PatientSearchStatus = 'FOUND' | 'AMBIGUOUS' | 'NOT_FOUND'

/**
 * Create patient form schema for scheduler. The insurance starts empty and
 * must be chosen explicitly (KO-71); `""` fails validation.
 */
export const CreatePatientSchema = Schema.Struct({
  firstName: Schema.String.pipe(Schema.check(Schema.isMinLength(1, { message: 'validation.required' }))),
  lastName: Schema.String.pipe(Schema.check(Schema.isMinLength(1, { message: 'validation.required' }))),
  dateOfBirth: Schema.String.pipe(Schema.check(Schema.isMinLength(1, { message: 'validation.required' }))),
  insurance: Schema.Union([InsuranceSchema, Schema.Literal('')]).pipe(
    Schema.check(Schema.makeFilter((value) => value !== '', { message: 'self-service.identification.create.insurance-required' }))
  )
})

export type CreatePatientData = Schema.Schema.Type<typeof CreatePatientSchema>

/**
 * Confirmation form schema for optional appointment notes.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const schema = SchedulerConfirmationSchema
 * ```
 */
export const SchedulerConfirmationSchema = Schema.Struct({
  description: Schema.String.pipe(
    Schema.check(Schema.isMaxLength(500, {
      message: 'self-service.scheduler.confirmation.description-too-long'
    }))
  )
})

export type SchedulerConfirmationData = Schema.Schema.Type<typeof SchedulerConfirmationSchema>
